import { Button, Dialog, VisuallyHidden } from '@betterment/samba-react';
import { HtmlContent } from '@betterment/shared-components';

interface BalanceDisclosureModalProps {
  disclosure: DocumentFragment;
}

export const BalanceDisclosureModal: React.FC<BalanceDisclosureModalProps> = ({ disclosure }) => {
  return (
    <Dialog>
      <Dialog.Trigger asChild={true}>
        <Button variant="textSecondary" css={{ color: 'text.weak', fontSize: 'fontSize.25' }}>
          See disclosure
        </Button>
      </Dialog.Trigger>
      <Dialog.Content size="large" css={{ p: 'space.400' }}>
        <Dialog.Title>
          <VisuallyHidden>Balance Disclosure</VisuallyHidden>
        </Dialog.Title>
        <Dialog.Description asChild={true}>
          <HtmlContent documentFragment={disclosure} />
        </Dialog.Description>
      </Dialog.Content>
    </Dialog>
  );
};
